var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ticket, admit, vip"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    d: "M11.4375 5.8125V6.1875M11.4375 8.8125V9.1875M11.4375 11.8125V12.1875M3.5625 3.5625H14.4375C15.2659 3.5625 15.9375 4.23407 15.9375 5.0625V6.9375C13.875 7.5 13.875 10.5 15.9375 11.0625V12.9375C15.9375 13.7659 15.2659 14.4375 14.4375 14.4375H3.5625C2.73407 14.4375 2.0625 13.7659 2.0625 12.9375V11.0625C4.125 10.5 4.125 7.5 2.0625 6.9375V5.0625C2.0625 4.23407 2.73407 3.5625 3.5625 3.5625Z",
    stroke: "#FF7926",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.a6313b497fa426f1e96231f2f3da51ed.svg";
export { ForwardRef as ReactComponent };